import { constants } from '../../Configs/constants';

const { CONTACTS, ABOUT } = constants.urls;

export const measureScrollRails = el => {
  const scrollDiv = document.createElement('div');
  const position = el.style.position;
  el.style.position = 'relative';
  scrollDiv.setAttribute(
    'style',
    'width:100px;height:100px;overflow:scroll;position:absolute;top:-9999px;',
  );
  el.appendChild(scrollDiv);
  const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  el.removeChild(scrollDiv);
  el.style.position = position;
  return scrollbarWidth;
};

export const handleImageError = image => e => {
  const soruces = e.target.closest('picture')?.querySelectorAll('source');
  soruces && soruces.forEach(el => el.remove());
  e.target.src = image;
};

let to = null;

export const scrollOnPush = (loc, action) => {
  if (action === 'PUSH') {
    clearTimeout(to);
    let timeout = 0;
    let hashElement = document.body;
    if (loc.pathname === CONTACTS) {
      timeout = 400;
      hashElement = document.getElementById('kontaktai');
    }
    if (loc.pathname === ABOUT) {
      timeout = 400;
      hashElement = document.getElementById('apie_mus');
    }
    to = setTimeout(() => {
      if (loc.pathname === CONTACTS) {
        hashElement = document.getElementById('kontaktai');
      }
      if (loc.pathname === ABOUT) {
        hashElement = document.getElementById('apie_mus');
      }
      hashElement && hashElement.scrollIntoView({ behavior: 'smooth' });
    }, timeout);
  }
};

export const phoneFormat = input => {
  const phone = '' + input;
  const match = phone.match(/^(\+?)\s*(\d{3})\s*(\d{3})\s*(\d{5,})$/) || [];
  if (match[0]) {
    return [match[1] || '+', ' ', match[2], ' ', match[3], ' ', match[4]].join(
      '',
    );
  } else return input;
};
